/* src/app/private/components/leads/lead-timeline/lead-timeline.component.scss */
.timeline-marker {
  background-color: var(--primary-color) !important;
  color: #fff;
  font-weight: 600;
  font-size: 11px;
}
.status-badge {
  animation: fadeIn 0.3s ease-in-out;
  transition: all 0.2s ease;
}
.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.status-badge.status-completed {
  background: #d1fae5 !important;
  color: #065f46 !important;
  border: 1px solid #10b981;
}
.status-badge.status-pending {
  background: #fef3c7 !important;
  color: #92400e !important;
  border: 1px solid #f59e0b;
}
.status-badge.status-in-progress {
  background: #dbeafe !important;
  color: #1e40af !important;
  border: 1px solid var(--primary-color);
}
.status-badge.status-cancelled,
.status-badge.status-rejected {
  background: #fee2e2 !important;
  color: #991b1b !important;
  border: 1px solid #ef4444;
}
.status-badge.status-approved {
  background: #d1fae5 !important;
  color: #065f46 !important;
  border: 1px solid #10b981;
}
.status-badge.status-default {
  background: var(--secondry-light-gray) !important;
  color: var(--text-color) !important;
  border: 1px solid var(--surface-border);
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.timeline-content-card button {
  transition: all 0.15s ease;
}
.timeline-content-card button:hover {
  transform: scale(1.05);
}
.timeline-content-card button:hover:has(.pi-pen-to-square) {
  background: var(--primary-color) !important;
  opacity: 0.1;
}
.timeline-content-card button:hover:has(.pi-pen-to-square) .pi-pen-to-square {
  color: var(--primary-color) !important;
}
.timeline-content-card button:hover:has(.pi-trash) {
  background: #ef4444 !important;
  opacity: 0.1;
}
.timeline-content-card button:hover:has(.pi-trash) .pi-trash {
  color: #ef4444 !important;
}
.lead-timeline .custom-timeline ::ng-deep .p-timeline .p-timeline-event {
  margin-bottom: 0rem !important;
}
.lead-timeline .custom-timeline ::ng-deep .p-timeline .p-timeline-event:last-child {
  margin-bottom: 0 !important;
}
.lead-timeline .custom-timeline ::ng-deep .p-timeline .p-timeline-event-connector {
  background: var(--secondry-light-gray) !important;
  width: 3px !important;
}
.lead-timeline .timeline-content-card {
  position: relative;
  margin-left: 1rem;
  margin-top: 0rem;
  margin-bottom: 1.25rem;
}
.lead-timeline .timeline-content-card:hover {
  transform: translateY(-2px);
  transition: all 0.2s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
}
.lead-timeline .timeline-marker {
  background: var(--primary-color) !important;
  color: var(--primary-contrast-color) !important;
  font-weight: 600;
  font-size: 11px;
  border: 3px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 10;
}
.lead-timeline .description-content {
  color: var(--text-color) !important;
  line-height: 1.6;
}
.lead-timeline .description-content .action-header {
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 1rem;
  font-size: 0.95rem;
  padding: 0.75rem 1rem;
  background:
    linear-gradient(
      135deg,
      var(--primary-color),
      rgba(var(--primary-color), 0.8));
  color: var(--primary-contrast-color);
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}
.lead-timeline .description-content .details-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: rgba(var(--secondry-light-gray), 0.2);
  border-radius: 0.5rem;
  border: 1px solid var(--surface-border);
}
.lead-timeline .description-content .list-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  background: white;
  border-radius: 0.375rem;
  border: 1px solid rgba(var(--surface-border), 0.3);
  transition: all 0.2s ease;
  position: relative;
}
.lead-timeline .description-content .list-item:hover {
  background: var(--secondry-light-gray);
  transform: translateX(4px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}
.lead-timeline .description-content .list-item.important {
  background:
    linear-gradient(
      135deg,
      rgba(var(--primary-color), 0.08),
      rgba(var(--primary-color), 0.04));
  border-left: 4px solid var(--primary-color);
  padding-left: 1rem;
}
.lead-timeline .description-content .list-item.important .list-bullet {
  background: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(var(--primary-color), 0.2);
}
.lead-timeline .description-content .list-item.important .field-label {
  color: var(--primary-color);
  font-weight: 700;
}
.lead-timeline .description-content .list-item.important .field-value {
  font-weight: 600;
}
.lead-timeline .description-content .list-item .list-bullet {
  width: 8px;
  height: 8px;
  background: var(--text-color-secondary);
  border-radius: 50%;
  margin-top: 0.375rem;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
.lead-timeline .description-content .list-item .list-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}
@media (min-width: 640px) {
  .lead-timeline .description-content .list-item .list-content {
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
  }
}
.lead-timeline .description-content .list-item .field-label {
  font-weight: 600;
  color: var(--text-color-secondary);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 140px;
  flex-shrink: 0;
}
@media (max-width: 639px) {
  .lead-timeline .description-content .list-item .field-label {
    min-width: auto;
    margin-bottom: 0.125rem;
  }
}
.lead-timeline .description-content .list-item .field-value {
  color: var(--text-color);
  font-size: 0.9rem;
  line-height: 1.4;
  word-break: break-words;
  flex: 1;
}
.lead-timeline .description-content .quoted-highlight {
  background:
    linear-gradient(
      120deg,
      var(--primary-color) 0%,
      transparent 100%);
  background-size: 100% 0.2em;
  background-repeat: no-repeat;
  background-position: 0 85%;
  color: var(--primary-color);
  font-weight: 500;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  position: relative;
}
.lead-timeline .description-content .quoted-highlight::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--primary-color);
  opacity: 0.1;
  border-radius: 0.25rem;
  z-index: -1;
}
.lead-timeline .description-content .date-value {
  color: var(--primary-color);
  font-weight: 600;
  font-family:
    "Segoe UI",
    system-ui,
    sans-serif;
  background:
    linear-gradient(
      135deg,
      var(--secondry-light-gray),
      white);
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  border: 1px solid var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.lead-timeline .description-content .na-value {
  color: var(--text-color-secondary);
  font-style: italic;
  opacity: 0.7;
  background: rgba(var(--text-color-secondary), 0.1);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}
.lead-timeline .description-content .yes-value {
  color: #10b981;
  font-weight: 600;
  background: #d1fae5;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  border: 1px solid #10b981;
}
.lead-timeline .description-content .no-value {
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db;
}
.lead-timeline .description-content .regular-value {
  color: var(--text-color);
  font-weight: 500;
}
.lead-timeline .description-content .contact-method {
  background:
    linear-gradient(
      135deg,
      #dbeafe,
      #bfdbfe);
  color: #1e40af;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  border: 1px solid #3b82f6;
  box-shadow: 0 1px 2px rgba(59, 130, 246, 0.1);
}
.lead-timeline .description-content .contact-method:hover {
  background:
    linear-gradient(
      135deg,
      #bfdbfe,
      #93c5fd);
  transform: translateY(-1px);
}
.lead-timeline .description-content .status-value {
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
}
.lead-timeline .description-content .status-value.status-completed {
  background: #d1fae5;
  color: #065f46;
}
.lead-timeline .description-content .status-value.status-pending {
  background: #fef3c7;
  color: #92400e;
}
.lead-timeline .description-content .status-value.status-in-progress {
  background: #dbeafe;
  color: #1e40af;
}
.lead-timeline .description-content .status-value.status-cancelled,
.lead-timeline .description-content .status-value.status-rejected {
  background: #fee2e2;
  color: #991b1b;
}
.lead-timeline .description-content .status-value.status-approved {
  background: #d1fae5;
  color: #065f46;
}
/*# sourceMappingURL=lead-timeline.component.css.map */
